module.exports = __webpack_public_path__ + "officialStatic/img/trusteeship1.95fb232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/trusteeship1.png
// module id = qKx6
// module chunks = 0